import { render, staticRenderFns } from "./SelectPanel.vue?vue&type=template&id=4252106b&scoped=true&"
import script from "./SelectPanel.vue?vue&type=script&lang=js&"
export * from "./SelectPanel.vue?vue&type=script&lang=js&"
import style0 from "./SelectPanel.vue?vue&type=style&index=0&id=4252106b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4252106b",
  null
  
)

export default component.exports